import React from 'react'
import './ProductCollectionTitle.css'

type ProductCollectionTitleProps = {
	title: string
	titleHex?: string
	className?: string
	as?: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span'
}

const ProductCollectionTitle: React.FC<ProductCollectionTitleProps> = ({
	title,
	titleHex,
	className = '',
	as = 'h3',
}) => {
	const Tag = as
	const isSpecialCustom = titleHex === 'SPECIAL_CUSTOM'
	const titleStyle = !isSpecialCustom && titleHex ? { color: titleHex } : undefined
	const classes = `${className} ${isSpecialCustom ? 'product-collection-title-special-custom' : ''}`.trim()

	return (
		<Tag className={classes} style={titleStyle}>
			{isSpecialCustom && (
				<>
					<span className="product-collection-title-shape product-collection-title-shape-circle-1" />
					<span className="product-collection-title-shape product-collection-title-shape-circle-2" />
					<span className="product-collection-title-shape product-collection-title-shape-square-1" />
					<span className="product-collection-title-shape product-collection-title-shape-square-2" />
					<span className="product-collection-title-shape product-collection-title-shape-pill-1" />
					<span className="product-collection-title-shape product-collection-title-shape-pill-2" />
				</>
			)}
			{title}
		</Tag>
	)
}

export default ProductCollectionTitle
